import React, { useEffect } from 'react';

const H1BIntake = () => {
  // Optional: Scroll to top when mounted
  useEffect(() => {
    window.scrollTo(0, 0);
    // Hide body scroll to prevent scrolling the site behind the full-screen iframe
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      width: '100vw', 
      height: '100vh', 
      zIndex: 999999, 
      backgroundColor: '#fff' 
    }}>
      <iframe 
        src="https://hub.prophecytechs.com/disensystem-h1b" 
        width="100%" 
        height="100%" 
        style={{ border: 'none', display: 'block' }} 
        title="Disensystems H-1B Intake Form">
      </iframe>
    </div>
  );
};

export default H1BIntake;
